import { useProjects } from '../lib/queries';

export function ProjectsPage() {
  const q = useProjects();
  if (q.isLoading) return <p className="text-muted">Loading projects…</p>;
  if (q.isError)
    return <p className="text-red-400">Failed to load projects: {(q.error as Error).message}</p>;
  const rows = q.data?.projects ?? [];
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold">Projects</h1>
      {rows.length === 0 ? (
        <div className="bg-surface border border-border rounded-lg p-6 text-center text-muted">
          No projects yet.
        </div>
      ) : (
        <ul className="space-y-2">
          {rows.map((p) => (
            <li
              key={p.id}
              className="bg-surface border border-border rounded-lg p-4 flex items-center justify-between"
            >
              <div>
                <div className="font-medium">{p.name}</div>
                <div className="text-xs text-muted">
                  sample rate {p.sampleRate} Hz · created{' '}
                  {new Date(p.createdAt).toLocaleDateString()}
                </div>
              </div>
              {p.episodeId && (
                <span className="text-xs text-muted">linked to episode</span>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
